import Immutable from 'seamless-immutable';
import { handleActions } from 'redux-actions';
import { accounts as actionTypes } from '$constants/action-types';

const defaultState = Immutable({
  items: []
});

const reducer = {
  [actionTypes.CREATE_SUCCESS](state, action) {
    return state.set('current', action.result);
  },

  [actionTypes.LOGIN_SUCCESS](state, action) {
    return state.set('current', action.result);
  },

  [actionTypes.FETCH_CURRENT_SUCCESS](state, action) {
    return state.set('current', action.result);
  }
}

reducer[actionTypes.LOGIN_SUCCESS] = reducer[actionTypes.CREATE_SUCCESS];

export default handleActions(reducer, defaultState);



// WEBPACK FOOTER //
// ./src/reducers/accounts.js